var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"nav nav-mobile-menu"},[_c('drop-down',[_c('template',{slot:"title"},[_c('i',{staticClass:"nc-icon nc-bullet-list-67"})]),_c('a',{staticClass:"dropdown-item text-danger",attrs:{"href":"javascript:;"},on:{"click":_vm.logout}},[_c('i',{staticClass:"nc-icon nc-button-power"}),_vm._v(" Cerrar sesión ")])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }